import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import {
  Table,
  message,
  Space,
  Popconfirm,
  Spin,
  Typography,
  Modal,
} from "antd";
import store from "../../../../../store/index";
import {
  getTaxEnterpriseList,
  taxEnterpriseUpdateStatus,
  getAuthCompanyUrl,
  getBeforeAuthSign,
} from "../../api";
const { Paragraph, Link } = Typography;
const TableList = (props, ref) => {
  let path = "platform:taxEnterprise";
  const { refresh } = props;
  const [tableData, setTableData] = useState([]);
  const [previewTitle, setpreviewTitle] = useState("认证链接");
  const [textUrl, settextUrl] = useState("");
  const [previewVisible, setpreviewVisible] = useState(false);
  useImperativeHandle(ref, () => ({
    // showModal 就是暴露给父组件的方法
    getlist: () => {
      getTableLists();
    },
  }));
  const getTableLists = async () => {
    let result = await getTaxEnterpriseList();
    if (result.data.success) {
      setTableData(result.data.data);
    } else {
      message.error(result.data.retMsg);
    }
  };
  const handelView = async (row, title) => {
    setpreviewTitle(title);
    let result;
    if (title == "认证链接") {
      result = await getAuthCompanyUrl({ code: row.code });
    } else {
      result = await getBeforeAuthSign({ code: row.code });
    }
    if (result.data.success) {
      settextUrl(result.data.data);
      setpreviewVisible(true);
    } else {
      message.error(result.data.retMsg);
    }
  };
  const handlestatus = async (record) => {
    let status = record.status == 1 ? 0 : 1;
    let result = await taxEnterpriseUpdateStatus({
      code: record.code,
      status: status,
    });
    if (result.data.success) {
      message.success(result.data.retMsg);
      refresh("query");
    } else {
      message.error(result.data.retMsg);
    }
  };

  const handUpSeal = (record) => {
    refresh("upSeal", record);
  };

  // 列表字段
  const tableColumns = [
    {
      title: "创建时间",
      dataIndex: "createTime",
      key: "createTime",
      align: "center",
      width: 170,
    },
    {
      title: "公司编码",
      dataIndex: "code",
      key: "code",
      align: "center",
      width: 140,
    },
    {
      title: "结算企业名称",
      dataIndex: "enterpriseName",
      key: "enterpriseName",
      align: "center",
      width: 240,
    },
    {
      title: "结算企业简称",
      dataIndex: "shortName",
      key: "shortName",
      align: "center",
      width: 110,
    },
    {
      title: "落地省份",
      dataIndex: "provinceName",
      key: "provinceName",
      align: "center",
      width: 110,
    },
    {
      title: "落地城市",
      dataIndex: "cityName",
      key: "cityName",
      align: "center",
      width: 110,
    },
    {
      title: "落地区县",
      dataIndex: "countyName",
      key: "countyName",
      align: "center",
      width: 110,
    },
    {
      title: "认证状态",
      dataIndex: "certificationFlag",
      key: "certificationFlag",
      align: "center",
      width: 100,
      render: (certificationFlag, record) => (
        <Space>
          <span>{certificationFlag == 1 ? "实名 " : "未实名 "}</span>{" "}
        </Space>
      ),
    },
    {
      title: "授权状态",
      dataIndex: "authorizationFlag",
      key: "authorizationFlag",
      align: "center",
      width: 100,
      render: (authorizationFlag, record) => (
        <Space>
          <span>{authorizationFlag == 1 ? "授权 " : "未授权 "}</span>{" "}
        </Space>
      ),
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "status",
      align: "center",
      width: 70,
      render: (status, record) => (
        <Space>
          <span>{status == 1 ? "启用" : "停用"}</span>{" "}
        </Space>
      ),
    },
    {
      title: "操作",
      key: "control",
      fixed: "right",
      width: 210,
      align: "center",
      render: (record) => {
        let title = "";
        if (record.status == 1) {
          title = "停用";
        } else {
          title = "启用";
        }
        return (
          <Space>
            {store
              .getState()
              .userReducer.permissions.includes(`${path}:list`) &&
              record.certificationFlag != 1 && (
                <Link onClick={() => handelView(record, "认证链接")}>
                  认证链接
                </Link>
              )}
            {store
              .getState()
              .userReducer.permissions.includes(`${path}:list`) &&
              record.authorizationFlag != 1 && (
                <Link onClick={() => handelView(record, "授权链接")}>
                  授权链接
                </Link>
              )}
            {store
              .getState()
              .userReducer.permissions.includes(`${path}:updateStatus`) && (
              <Popconfirm
                title={`确定${title}吗？`}
                onConfirm={() => {
                  handlestatus(record);
                }}
                okText="确定"
                cancelText="取消"
                className="marginLeft"
              >
                <Link>{title}</Link>
              </Popconfirm>
            )}
            {store
              .getState()
              .userReducer.permissions.includes(`${path}:updateSealUrl`) && (
              <Link
                onClick={() => {
                  handUpSeal(record);
                }}
              >
                上传
              </Link>
            )}
          </Space>
        );
      },
    },
  ];
  useEffect(() => {
    getTableLists();
  }, []);
  return (
    <Spin spinning={false}>
      <Table
        columns={tableColumns}
        dataSource={tableData}
        scroll={{ x: 1600, y: 500 }}
        rowKey={(record) => record.code}
        pagination={false}
      />
      <Modal
        maskClosable={false}
        width={800}
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => {
          setpreviewVisible(false);
        }}
      >
        <Paragraph
          ellipsis={{
            rows: 2,
          }}
          copyable={{
            text: textUrl,
            tooltips: ["点击复制", "复制成功"],
          }}
        >
          {textUrl}
        </Paragraph>
      </Modal>
    </Spin>
  );
};
export default forwardRef(TableList);
